export default "__VITE_ASSET__0YPBSgMR__"